



import React, { useState, useEffect } from "react";
import { FaTrash, FaPlus, FaSpinner, FaUpload, FaTimes, FaEdit } from "react-icons/fa";
import Modal from "react-modal";
import * as XLSX from "xlsx";
import { Link } from "react-router-dom";

Modal.setAppElement("#root");

// Inline loader hook 
const useInlineLoader = () => {
    const [loading, setLoading] = useState(false);
    const [fadeOut, setFadeOut] = useState(false);

    const showLoader = () => {
        setFadeOut(false);
        setLoading(true);
    };

    const hideLoader = () => {
        setFadeOut(true);
        setTimeout(() => {
            setLoading(false);
            setFadeOut(false);
        }, 500);
    };
    return { showLoader, hideLoader, loading, fadeOut };
};


export default function Foodcustomizemenu() {
    const [isQuickModal, setIsQuickModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [categories, setCategories] = useState([]);
    const [dishes, setDishes] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [filteredDishes, setFilteredDishes] = useState([]);
    const [isSaving, setIsSaving] = useState(false);
    const [hoveredDelete, setHoveredDelete] = useState(null);
    const [hoveredEdit, setHoveredEdit] = useState(null);
    // Use inline loader
    const { showLoader, hideLoader, loading: globalLoading, fadeOut } = useInlineLoader();
    const [quickForm, setQuickForm] = useState({
        catageory: "",
        image: null,
    });

    const [isDetailModal, setIsDetailModal] = useState(false);
    const [detailForm, setDetailForm] = useState({
        id: "", // For editing
        catageoryId: "",
        dishName: "",
        image: null,
    });

    const [selectedCategoryName, setSelectedCategoryName] = useState("");
    const [scrollProgress, setScrollProgress] = useState(0);

    // State for edit category modal
    const [isEditCategoryModal, setIsEditCategoryModal] = useState(false);
    const [editCategoryForm, setEditCategoryForm] = useState({
        catageoryId: "",
        catageoryName: "",
        image: null,
        currentImage: ""
    });

    // State for edit dish modal
    const [isEditDishModal, setIsEditDishModal] = useState(false);
    const [editDishForm, setEditDishForm] = useState({
        id: "",
        name: "",
        image: null,
        currentImage: "",
        catageoryId: ""
    });

    // Handle scroll progress
    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.pageYOffset;
            const docHeight = document.documentElement.scrollHeight - window.innerHeight;
            const scrollPercent = scrollTop / docHeight;
            setScrollProgress(scrollPercent);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // Handle adding new dish to a category
    const handleAddClick = (category) => {
        setIsDetailModal(true);
        setDetailForm({
            id: "",
            catageoryId: category.catageoryId,
            dishName: "",
            image: null,
        });
        setSelectedCategoryName(category.catageoryName);
    };

    const handleDetailSave = async () => {
        try {
            const authToken = localStorage.getItem("authToken");

            if (!detailForm.catageoryId) {
                alert("Please select category");
                return;
            }

            if (!detailForm.dishName?.trim()) {
                alert("Please enter dish name");
                return;
            }

            if (!detailForm.image) {
                alert("Please select image");
                return;
            }

            const formData = new FormData();

            // ✅ categoryId — application/json (like Postman)
            formData.append(
                "categoryId",
                new Blob(
                    [String(detailForm.catageoryId)],
                    { type: "application/json" }
                )
            );

            // ✅ dish — application/json (like Postman)
            formData.append(
                "dish",
                new Blob(
                    [
                        JSON.stringify({
                            name: detailForm.dishName.trim()
                        })
                    ],
                    { type: "application/json" }
                )
            );

            // ✅ image — REAL FILE (image/jpeg or image/avif)
            formData.append("image", detailForm.image);

            // Show loader
            showLoader();

            const response = await fetch(
                "https://backend.maamaas.com/food/api/admin/dish/upload",
                {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${authToken}`
                        // ❌ DO NOT set Content-Type
                    },
                    body: formData
                }
            );

            const text = await response.text();
            console.log("Server response:", text);

            if (!response.ok) {
                throw new Error(text);
            }

            alert("✅ Dish added successfully");

            // ✅ ADD THIS: Close the modal
            setIsDetailModal(false);

            // ✅ ADD THIS: Reset the form
            setDetailForm({
                id: "",
                catageoryId: "",
                dishName: "",
                image: null,
            });
            setSelectedCategoryName("");

            // Refresh data
            fetchData();

        } catch (err) {
            console.error("Dish save error:", err);
            alert("❌ " + err.message);
        } finally {
            hideLoader();
        }
    };

    // GET Dish by ID - for editing
    const handleEditDishClick = async (dishId) => {
        try {
            showLoader();
            const authToken = localStorage.getItem("authToken");

            const response = await fetch(
                `https://backend.maamaas.com/food/api/dish/${dishId}`,
                {
                    headers: authToken ? {
                        Authorization: `Bearer ${authToken}`
                    } : {}
                }
            );

            if (!response.ok) {
                throw new Error(`Failed to fetch dish: ${response.status}`);
            }

            const dishData = await response.json();

            setEditDishForm({
                id: dishData.id,
                name: dishData.name,
                image: null,
                currentImage: dishData.image || "",
                catageoryId: dishData.category?.catageoryId || ""
            });

            setIsEditDishModal(true);
        } catch (err) {
            console.error("Error fetching dish:", err);
            alert("Failed to load dish details: " + err.message);
        } finally {
            hideLoader();
        }
    };

    // PUT - Update Dish
    const handleUpdateDish = async () => {
        if (!editDishForm.name.trim()) {
            alert("Please enter dish name!");
            return;
        }

        try {
            setIsSaving(true);
            showLoader();
            const authToken = localStorage.getItem("authToken");
            if (!authToken) {
                alert("Please login again");
                return;
            }

            // Find category for the dish
            const dish = dishes.find(d => d.id === parseInt(editDishForm.id));
            const category = categories.find(cat => cat.catageoryId === dish?.catageoryId);

            const dishObj = {
                id: editDishForm.id,
                name: editDishForm.name.trim(),
                image: editDishForm.currentImage,
                category: {
                    catageoryId: category?.catageoryId || "",
                    catageoryName: category?.catageoryName || "",
                    image: category?.image || ""
                }
            };

            const formData = new FormData();
            formData.append("categoryId", editDishForm.catageoryId);

            // ✅ Append dish as a Blob with proper JSON content type
            formData.append(
                "dish",
                new Blob([JSON.stringify(dishObj)], {
                    type: "application/json"
                }),
                "dish.json"
            );

            if (editDishForm.image) {
                formData.append("image", editDishForm.image);
            }

            const response = await fetch(
                `https://backend.maamaas.com/food/api/edit/dish/${editDishForm.id}`,
                {
                    method: "PUT",
                    headers: {
                        Authorization: `Bearer ${authToken}`,
                    },
                    body: formData,
                }
            );

            const text = await response.text();

            if (!response.ok) {
                let errorMessage = `Server error: ${response.status}`;
                try {
                    const errorJson = JSON.parse(text);
                    errorMessage += ` - ${errorJson.message || errorJson.error || text}`;
                } catch (e) {
                    errorMessage += ` - ${text}`;
                }
                throw new Error(errorMessage);
            }

            alert("✅ Dish updated successfully!");
            setIsEditDishModal(false);
            setEditDishForm({ id: "", name: "", image: null, currentImage: "", catageoryId: "" });
            fetchData();

        } catch (err) {
            console.error("Dish update error:", err);
            alert("❌ Failed to update dish: " + (err.message || "Unknown error"));
        } finally {
            setIsSaving(false);
            hideLoader();
        }
    };

    // Handle edit category click
    const handleEditCategoryClick = (category) => {
        setEditCategoryForm({
            catageoryId: category.catageoryId,
            catageoryName: category.catageoryName,
            image: null,
            currentImage: category.image || ""
        });
        setIsEditCategoryModal(true);
    };

    // PUT - Update Category
    const handleUpdateCategory = async () => {
        if (!editCategoryForm.catageoryName.trim()) {
            alert("Please enter category name!");
            return;
        }

        try {
            setIsLoading(true);
            showLoader();
            const authToken = localStorage.getItem("authToken");
            if (!authToken) {
                alert("Please login again");
                return;
            }

            const categoryObj = {
                catageoryId: editCategoryForm.catageoryId,
                catageoryName: editCategoryForm.catageoryName.trim(),
                image: editCategoryForm.currentImage
            };

            const formData = new FormData();
            formData.append(
                "category",
                new Blob([JSON.stringify(categoryObj)], {
                    type: "application/json"
                })
            );

            if (editCategoryForm.image) {
                formData.append("categoryImg", editCategoryForm.image);
            }

            const response = await fetch(
                `https://backend.maamaas.com/food/api/admin/category/${editCategoryForm.catageoryId}`,
                {
                    method: "PUT",
                    headers: {
                        Authorization: `Bearer ${authToken}`
                    },
                    body: formData
                }
            );

            const text = await response.text();
            if (!response.ok) throw new Error(text);

            alert("✅ Category updated successfully!");
            setIsEditCategoryModal(false);
            setEditCategoryForm({ catageoryId: "", catageoryName: "", image: null, currentImage: "" });
            fetchData();

        } catch (err) {
            console.error("Category update error:", err);
            alert("❌ Category update failed: " + err.message);
        } finally {
            setIsLoading(false);
            hideLoader();
        }
    };

    // DELETE - Category (FIXED VERSION)
    const handleDeleteCategory = async (categoryId) => {
        if (!window.confirm("Are you sure you want to delete this category? All dishes in this category will also be deleted!")) return;

        try {
            setIsSaving(true);
            showLoader();
            const authToken = localStorage.getItem("authToken");
            if (!authToken) {
                alert("No auth token found. Please login.");
                return;
            }

            // First, get all dishes in this category
            const dishesInCategory = dishes.filter(dish => dish.catageoryId === categoryId);

            // Delete all dishes in the category first
            for (const dish of dishesInCategory) {
                const dishResponse = await fetch(
                    `https://backend.maamaas.com/food/api/delete/dish/${dish.id}`,
                    {
                        method: "DELETE",
                        headers: {
                            Authorization: `Bearer ${authToken}`
                        }
                    }
                );

                if (!dishResponse.ok) {
                    const text = await dishResponse.text();
                    throw new Error(`Failed to delete dish ${dish.id}: ${text}`);
                }
            }

            // Now delete the category
            const response = await fetch(
                `https://backend.maamaas.com/food/api/admin/category/${categoryId}`,
                {
                    method: "DELETE",
                    headers: {
                        Authorization: `Bearer ${authToken}`
                    }
                }
            );

            const text = await response.text();

            if (!response.ok) {
                throw new Error(`DELETE error! Status: ${response.status} | ${text}`);
            }

            // Animation for category row
            const categoryRow = document.querySelector(`[data-category-id="${categoryId}"]`);
            if (categoryRow) {
                categoryRow.style.opacity = '0';
                categoryRow.style.transform = 'translateX(-20px)';
                setTimeout(() => {
                    categoryRow.style.display = 'none';
                }, 300);
            }

            setTimeout(() => {
                alert("Category and all its dishes deleted successfully!");
                fetchData();
            }, 300);

        } catch (err) {
            console.error("Failed to delete category:", err);
            alert("Failed to delete category: " + (err.message || "Unknown error"));
        } finally {
            setIsSaving(false);
            hideLoader();
        }
    };

    // DELETE - Dish (ENHANCED VERSION)
    const handleDeleteDish = async (id) => {
        if (!window.confirm("Are you sure you want to delete this dish?")) return;

        try {
            setIsSaving(true);
            showLoader();
            const authToken = localStorage.getItem("authToken");
            if (!authToken) {
                alert("No auth token found. Please login.");
                return;
            }

            const response = await fetch(
                `https://backend.maamaas.com/food/api/delete/dish/${id}`,
                {
                    method: "DELETE",
                    headers: {
                        Authorization: `Bearer ${authToken}`
                    }
                }
            );

            const text = await response.text();

            if (!response.ok) {
                // Check if dish was already deleted (maybe by category deletion)
                if (response.status === 404) {
                    console.warn(`Dish ${id} not found, might have been already deleted`);
                    // Still remove from UI if it exists
                    const dishRow = document.querySelector(`[data-dish-id="${id}"]`);
                    if (dishRow) {
                        dishRow.style.opacity = '0';
                        dishRow.style.transform = 'translateX(-20px)';
                        setTimeout(() => {
                            dishRow.style.display = 'none';
                        }, 300);
                    }
                    alert("Dish deleted successfully!");
                    fetchData();
                    return;
                }
                throw new Error(`DELETE error! Status: ${response.status} | ${text}`);
            }

            // Add deletion animation
            const dishRow = document.querySelector(`[data-dish-id="${id}"]`);
            if (dishRow) {
                dishRow.style.opacity = '0';
                dishRow.style.transform = 'translateX(-20px)';
                setTimeout(() => {
                    dishRow.style.display = 'none';
                }, 300);
            }

            setTimeout(() => {
                alert("Dish deleted successfully!");
                fetchData();
            }, 300);

        } catch (err) {
            console.error("Failed to delete dish:", err);
            alert("Failed to delete dish: " + (err.message || "Unknown error"));
        } finally {
            setIsSaving(false);
            hideLoader();
        }
    };

    // CORRECTED getValidImageUrl function
    const getValidImageUrl = (url) => {
        if (!url || typeof url !== 'string' || url.trim() === "" ||
            url === "null" || url === "undefined" || url === "string") {
            return null;
        }

        if (url.startsWith("data:image/")) {
            return url;
        }

        if (url.startsWith("http://") || url.startsWith("https://")) {
            return url;
        }

        // Check if it's already a full URL from the fetch
        if (url.includes('amazonaws.com') || url.includes('X-Amz-')) {
            return url;
        }

        // Handle relative paths
        const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.jfif'];
        const hasImageExtension = imageExtensions.some(ext =>
            url.toLowerCase().endsWith(ext)
        );

        if (hasImageExtension) {
            // Check if it's a dishes_images or category_images path
            if (url.includes('dishes_images/')) {
                return `http://img.maamaas.com:8080/foodandbevarages/${url}`;
            } else if (url.includes('category_images/')) {
                return `http://img.maamaas.com:8080/foodandbevarages/${url}`;
            }
            // Fallback to old format
            return `https://backend.maamaas.com${url.startsWith('/') ? url : '/uploads/' + url}`;
        }

        return null;
    };

    const handleDetailChange = (e) => {
        const { name, value, files } = e.target;
        if (name === "image") {
            setDetailForm(prev => ({ ...prev, image: files[0] || null }));
        } else {
            setDetailForm(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleEditDishChange = (e) => {
        const { name, value, files } = e.target;
        if (name === "image") {
            setEditDishForm(prev => ({ ...prev, image: files[0] || null }));
        } else {
            setEditDishForm(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleEditCategoryChange = (e) => {
        const { name, value, files } = e.target;
        if (name === "image") {
            setEditCategoryForm(prev => ({ ...prev, image: files[0] || null }));
        } else {
            setEditCategoryForm(prev => ({ ...prev, [name]: value }));
        }
    };

    // Fetch categories and dishes
    const fetchData = async () => {
        setLoading(true);
        setError(null);
        try {
            showLoader();
            const authToken = localStorage.getItem("authToken");
            const headers = authToken ? { Authorization: `Bearer ${authToken}` } : {};

            // 1. First fetch all categories
            const categoriesResponse = await fetch(
                "https://backend.maamaas.com/food/api/getall/catageory-dish",
                { headers }
            );

            let categoriesData = [];
            if (categoriesResponse.ok) {
                const data = await categoriesResponse.json();
                console.log("Raw categories data:", data);

                // Handle different response structures
                if (Array.isArray(data)) {
                    categoriesData = data;
                } else if (data.data && Array.isArray(data.data)) {
                    categoriesData = data.data;
                } else if (data.categories && Array.isArray(data.categories)) {
                    categoriesData = data.categories;
                } else if (data.result && Array.isArray(data.result)) {
                    categoriesData = data.result;
                }

                setCategories(categoriesData);
            } else {
                console.error("Failed to fetch categories:", categoriesResponse.status);
                setCategories([]);
            }

            // 2. Fetch all dishes
            const dishesResponse = await fetch(
                "https://backend.maamaas.com/food/api/getall/dish",
                { headers }
            );

            let dishesData = [];
            if (dishesResponse.ok) {
                const data = await dishesResponse.json();
                console.log("Raw dishes API response:", data);

                // Handle different response structures
                if (Array.isArray(data)) {
                    dishesData = data;
                } else if (data.data && Array.isArray(data.data)) {
                    dishesData = data.data;
                } else if (data.dishes && Array.isArray(data.dishes)) {
                    dishesData = data.dishes;
                } else if (data.result && Array.isArray(data.result)) {
                    dishesData = data.result;
                }

                console.log("Processed dishes data:", dishesData);

                // Transform dishes data with better error handling
                const transformedDishes = dishesData.map(dish => {
                    // Handle different possible field names
                    const dishId = dish.id || dish.dishId || dish.dishID || "";
                    const dishName = dish.name || dish.dishName || dish.dish || "";
                    const dishImage = dish.image || dish.imageUrl || dish.img || "";
                    const category = dish.category || dish.catageory || dish.cat || {};
                    const categoryId = category?.catageoryId || category?.categoryId ||
                        category?.id || dish.catageoryId || dish.categoryId || null;
                    const categoryName = category?.catageoryName || category?.categoryName ||
                        category?.name || "";

                    return {
                        id: dishId,
                        name: dishName,
                        image: dishImage,
                        catageoryId: categoryId,
                        categoryName: categoryName,
                        categoryImage: category?.image || ""
                    };
                }).filter(dish => dish.id); // Only include dishes with an ID

                console.log("Transformed dishes:", transformedDishes);
                setDishes(transformedDishes);
                setFilteredDishes(transformedDishes);

            } else {
                const errorText = await dishesResponse.text();
                console.error("Failed to fetch dishes:", dishesResponse.status, errorText);
                setDishes([]);
                setFilteredDishes([]);
            }

        } catch (err) {
            console.error("Error fetching data:", err);
            setError(`Failed to load menu data: ${err.message}. Please try again.`);
        } finally {
            setLoading(false);
            hideLoader();
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    // Handle adding new category
    const handleQuickSave = async () => {
        if (!quickForm.catageory.trim()) {
            alert("Enter category name!");
            return;
        }

        try {
            setIsLoading(true);
            showLoader();

            const authToken = localStorage.getItem("authToken");
            if (!authToken) {
                alert("Please login again");
                return;
            }

            const categoryObj = {
                catageoryId: 0,
                catageoryName: quickForm.catageory.trim(),
                image: ""
            };

            const formData = new FormData();

            formData.append(
                "category",
                new Blob([JSON.stringify(categoryObj)], {
                    type: "application/json"
                })
            );

            if (quickForm.image) {
                formData.append("categoryImg", quickForm.image);
            }

            const response = await fetch(
                "https://backend.maamaas.com/food/api/admin/catageory-dish",
                {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${authToken}`
                    },
                    body: formData
                }
            );

            const text = await response.text();
            if (!response.ok) throw new Error(text);

            alert("✅ Category added successfully!");
            setIsQuickModal(false);
            setQuickForm({ catageory: "", image: null });
            fetchData();

        } catch (err) {
            console.error("Category add error:", err);
            alert("❌ Category add failed: " + err.message);
        } finally {
            setIsLoading(false);
            hideLoader();
        }
    };

    const handleQuickChange = (e) => {
        const { name, value, files } = e.target;
        if (name === "image" && files && files[0]) {
            setQuickForm(prev => ({ ...prev, image: files[0] }));
        } else {
            setQuickForm(prev => ({ ...prev, [name]: value }));
        }
    };

    // Handle exporting to Excel
    const handleExport = () => {
        if (dishes.length === 0) {
            alert("No dishes to export!");
            return;
        }

        const exportData = dishes.map(dish => ({
            "Dish ID": dish.id,
            "Dish Name": dish.name,
            "Category ID": dish.catageoryId,
        }));

        const ws = XLSX.utils.json_to_sheet(exportData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Food Menu");
        XLSX.writeFile(wb, "food_menu.xlsx");
    };

    // Group dishes by category for display
    const getDishesByCategory = (categoryId) => {
        if (!categoryId) return [];

        // Convert categoryId to string for comparison to handle different types
        const catIdStr = String(categoryId);
        return filteredDishes.filter(dish => {
            if (!dish.catageoryId) return false;
            return String(dish.catageoryId) === catIdStr;
        });
    };

    const handleRetry = () => {
        fetchData();
    };

    // Helper function to render image or placeholder with hover effect
    const renderImage = (url, alt) => {
        const imageUrl = getValidImageUrl(url);

        if (imageUrl) {
            return (
                <div className="image-container" style={{ position: 'relative', display: 'inline-block' }}>
                    <img
                        src={imageUrl}
                        alt={alt}
                        className="dish-image"
                        style={{
                            width: "50px",
                            height: "50px",
                            objectFit: "cover",
                            borderRadius: "8px",
                            border: "2px solid #e0e0e0",
                            transition: "all 0.3s ease",
                            cursor: "pointer"
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.transform = 'scale(1.1)';
                            e.target.style.boxShadow = '0 4px 15px rgba(0,0,0,0.2)';
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.transform = 'scale(1)';
                            e.target.style.boxShadow = 'none';
                        }}
                        onClick={() => {
                            const modal = document.createElement('div');
                            modal.style.position = 'fixed';
                            modal.style.top = '0';
                            modal.style.left = '0';
                            modal.style.width = '100%';
                            modal.style.height = '100%';
                            modal.style.backgroundColor = 'rgba(0,0,0,0.9)';
                            modal.style.display = 'flex';
                            modal.style.alignItems = 'center';
                            modal.style.justifyContent = 'center';
                            modal.style.zIndex = '9999';
                            modal.style.opacity = '0';
                            modal.style.transition = 'opacity 0.3s ease';

                            const img = document.createElement('img');
                            img.src = imageUrl;
                            img.alt = alt;
                            img.style.maxWidth = '90%';
                            img.style.maxHeight = '90%';
                            img.style.borderRadius = '10px';
                            img.style.transform = 'scale(0.9)';
                            img.style.transition = 'transform 0.3s ease';

                            modal.appendChild(img);
                            document.body.appendChild(modal);

                            setTimeout(() => {
                                modal.style.opacity = '1';
                                img.style.transform = 'scale(1)';
                            }, 10);

                            modal.onclick = () => {
                                modal.style.opacity = '0';
                                img.style.transform = 'scale(0.9)';
                                setTimeout(() => {
                                    document.body.removeChild(modal);
                                }, 300);
                            };
                        }}
                        onError={(e) => {
                            console.error("Image failed to load:", imageUrl);
                            e.target.style.display = 'none';
                            const parent = e.target.parentElement;
                            if (parent) {
                                parent.innerHTML = `
                                    <div style="width: 50px; height: 50px; background: linear-gradient(135deg, rgb(230 109 51) 0%, rgb(230 109 51) 100%); border-radius: 8px; border: 2px solid #e0e0e0; display: flex; align-items: center; justify-content: center; color: white; font-size: 10px; font-weight: bold; cursor: default;">
                                        No Image
                                    </div>
                                `;
                            }
                        }}
                        onLoad={(e) => {
                            console.log("Image loaded successfully:", imageUrl);
                        }}
                    />
                </div>
            );
        } else {
            console.log("No valid image URL for:", url);
            return (
                <div style={{ width: "50px", height: "50px", background: "linear-gradient(135deg, rgb(230 109 51) 0%, rgb(230 109 51) 100%)", borderRadius: "8px", border: "2px solid #e0e0e0", display: "flex", alignItems: "center", justifyContent: "center", color: "white", fontSize: "10px", fontWeight: "bold", cursor: "default" }}>
                    No Image
                </div>
            );
        }
    };

    return (
        <div className="container-fluid" style={{ marginTop: "120px", position: "relative" }}>
            {/* Global Loader */}
            {globalLoading && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: 'rgba(0,0,0,0.95)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 999999,
                    transition: 'opacity 0.4s ease',
                    fontFamily: 'Arial, sans-serif',
                    opacity: fadeOut ? 0 : 1,
                    pointerEvents: fadeOut ? 'none' : 'auto'
                }}>
                    <div style={{ textAlign: 'center' }}>
                        <div style={{
                            fontSize: '2rem',
                            fontWeight: 900,
                            letterSpacing: '6px',
                            marginBottom: '30px',
                        }}>
                            {"MAAMAAS".split("").map((l, i) => (
                                <span
                                    key={i}
                                    style={{
                                        display: 'inline-block',
                                        opacity: 0,
                                        transform: 'translateY(30px)',
                                        animation: `letterAnim 0.8s ease forwards ${i * 0.1}s`,
                                        color: '#e50914',
                                    }}
                                >
                                    {l}
                                </span>
                            ))}
                        </div>

                        <div style={{
                            width: '280px',
                            height: '4px',
                            background: 'rgba(255,255,255,0.2)',
                            overflow: 'hidden',
                            margin: '0 auto',
                        }}>
                            <div style={{
                                width: '40%',
                                height: '100%',
                                background: 'linear-gradient(90deg,#e50914,#ff6b6b)',
                                animation: 'progress 1.8s infinite',
                            }}></div>
                        </div>

                        <div style={{
                            marginTop: '20px',
                            color: '#aaa',
                            fontSize: '14px',
                        }}>
                            Preparing your experience...
                        </div>
                    </div>
                </div>
            )}

            {/* Scroll Progress Bar */}
            <div style={{
                position: "fixed",
                top: "0",
                left: "0",
                width: `${scrollProgress * 100}%`,
                height: "3px",
                background: "linear-gradient(90deg, #6c63ff, #ff6b6b)",
                zIndex: "1000",
                transition: "width 0.1s ease"
            }}></div>

            <div className="row">
                {/* <div className="col-lg-2"></div> */}
                <div className="col-lg-12">
                    <div className="menu-container">
                        {/* Enhanced Breadcrumb */}


                        {/* Enhanced Top Bar */}
                        <div className="top-bar" style={{
                            marginTop: "-155px",
                            marginBottom: "30px",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "20px",
                        }}>
                            <div className="left-side">
                                <button
                                    className="add-btn success-animation"
                                    onClick={() => setIsQuickModal(true)}
                                    style={{
                                        padding: "10px 10px",
                                        backgroundColor: "#28a745",

                                        color: "white",
                                        border: "none",
                                        marginLeft: "-18px",
                                        borderRadius: "8px",
                                        cursor: "pointer",
                                        fontSize: "16px",
                                        fontWeight: "bold",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "10px",
                                        boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
                                        transition: "all 0.3s ease",
                                        position: "relative",
                                        overflow: "hidden"
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.transform = "translateY(-3px)";
                                        e.target.style.boxShadow = "0 8px 25px rgba(0,0,0,0.2)";
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.transform = "translateY(0)";
                                        e.target.style.boxShadow = "0 4px 15px rgba(0,0,0,0.1)";
                                    }}
                                >
                                    <FaPlus /> Add Category
                                </button>
                            </div>
                            <div className="menu-right-side" style={{ display: "flex", gap: "15px" }}>
                                <button
                                    className="menu-export-btn"
                                    onClick={handleExport}
                                    disabled={dishes.length === 0}
                                    style={{
                                        padding: "12px 24px",
                                        background: "linear-gradient(135deg, rgb(230 109 51) 0%, rgb(230 109 51) 100%)",
                                        color: "white",
                                        border: "none",
                                        borderRadius: "8px",
                                        cursor: dishes.length === 0 ? "not-allowed" : "pointer",
                                        fontSize: "16px",
                                        fontWeight: "bold",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "10px",
                                        transition: "all 0.3s ease",
                                        boxShadow: dishes.length === 0 ? "none" : "0 4px 15px rgba(40, 167, 69, 0.3)"
                                    }}
                                    onMouseEnter={(e) => {
                                        if (dishes.length > 0) {
                                            e.target.style.transform = "translateY(-3px)";
                                            e.target.style.boxShadow = "0 8px 25px rgba(40, 167, 69, 0.4)";
                                        }
                                    }}
                                    onMouseLeave={(e) => {
                                        if (dishes.length > 0) {
                                            e.target.style.transform = "translateY(0)";
                                            e.target.style.boxShadow = "0 4px 15px rgba(40, 167, 69, 0.3)";
                                        }
                                    }}
                                >
                                    Export
                                </button>
                            </div>
                        </div>

                        {loading && (
                            <div style={{
                                textAlign: "center",
                                padding: "60px",
                                background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
                                borderRadius: "15px",
                                margin: "20px 0"
                            }}>
                                <div className="spinner" style={{
                                    width: "50px",
                                    height: "50px",
                                    border: "5px solid #f3f3f3",
                                    borderTop: "5px solid #6c63ff",
                                    borderRadius: "50%",
                                    animation: "spin 1s linear infinite",
                                    margin: "0 auto 20px"
                                }}></div>
                                <p style={{
                                    fontSize: "18px",
                                    color: "#666",
                                    fontWeight: "bold",
                                    background: "linear-gradient(90deg, #6c63ff, #ff6b6b)",
                                    WebkitBackgroundClip: "text",
                                    WebkitTextFillColor: "transparent"
                                }}>Loading menu data...</p>
                            </div>
                        )}

                        {error && !loading && (
                            <div style={{
                                textAlign: "center",
                                padding: "40px",
                                background: "linear-gradient(135deg, #ff9a9e 0%, #fad0c4 100%)",
                                borderRadius: "15px",
                                margin: "20px 0",
                                animation: "shake 0.5s ease"
                            }}>
                                <div style={{
                                    color: "#d32f2f",
                                    marginBottom: "20px",
                                    fontSize: "18px",
                                    fontWeight: "bold"
                                }}>
                                    ⚠️ {error}
                                </div>
                                <button
                                    className="btn btn-primary"
                                    onClick={handleRetry}
                                    style={{
                                        padding: "12px 30px",
                                        background: "linear-gradient(135deg, rgb(230 109 51) 0%, rgb(230 109 51) 100%)",
                                        color: "white",
                                        border: "none",
                                        borderRadius: "8px",
                                        cursor: "pointer",
                                        fontSize: "16px",
                                        fontWeight: "bold",
                                        transition: "all 0.3s ease",
                                        boxShadow: "0 4px 15px rgba(102, 126, 234, 0.3)"
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.transform = "translateY(-3px)";
                                        e.target.style.boxShadow = "0 8px 25px rgba(102, 126, 234, 0.4)";
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.transform = "translateY(0)";
                                        e.target.style.boxShadow = "0 4px 15px rgba(102, 126, 234, 0.3)";
                                    }}
                                >
                                    🔄 Retry
                                </button>
                            </div>
                        )}

                        {!loading && !error && (
                            <div style={{
                                overflowX: "hidden",
                                marginTop: "-40px",
                                border: "none",
                                borderRadius: "15px",
                                maxHeight: "470px",
                                overflowY: "auto",
                                background: "white",
                                boxShadow: "0 10px 40px rgba(0,0,0,0.1)",
                                position: "relative"
                            }}>
                                <table style={{
                                    width: "100%",
                                    borderCollapse: "collapse",
                                    minWidth: "auto",
                                    tableLayout: "fixed"
                                }}>
                                    <colgroup>
                                        <col style={{ width: "8%" }} />
                                        <col style={{ width: "40%" }} />
                                        <col style={{ width: "15%" }} />
                                        <col style={{ width: "37%" }} />
                                    </colgroup>
                                    <thead style={{
                                        position: "sticky",
                                        top: 0,
                                        zIndex: 10,
                                        background: "linear-gradient(135deg, rgb(230 109 51) 0%, rgb(230 109 51) 100%)"
                                    }}>
                                        <tr>
                                            <th style={{
                                                padding: "20px 10px",
                                                textAlign: "center",
                                                fontWeight: "bold",
                                                color: "white",
                                                fontSize: "16px",
                                                borderBottom: "none",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap"
                                            }}>
                                                S.No
                                            </th>
                                            <th style={{
                                                padding: "20px 10px",
                                                textAlign: "left",
                                                fontWeight: "bold",
                                                color: "white",
                                                fontSize: "16px",
                                                borderBottom: "none",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap"
                                            }}>
                                                Category/Dish
                                            </th>
                                            <th style={{
                                                padding: "20px 10px",
                                                textAlign: "center",
                                                fontWeight: "bold",
                                                color: "white",
                                                fontSize: "16px",
                                                borderBottom: "none",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap"
                                            }}>
                                                Image
                                            </th>
                                            <th style={{
                                                padding: "20px 10px",
                                                textAlign: "center",
                                                fontWeight: "bold",
                                                color: "white",
                                                fontSize: "16px",
                                                borderBottom: "none",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap"
                                            }}>
                                                Actions
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {categories && categories.length > 0 ? (
                                            categories.map((category, index) => {
                                                const categoryDishes = getDishesByCategory(category.catageoryId);

                                                return (
                                                    <React.Fragment key={category.catageoryId}>
                                                        {/* Category Row */}
                                                        <tr
                                                            data-category-id={category.catageoryId}
                                                            style={{
                                                                backgroundColor: "#f0f4ff",
                                                                borderBottom: "2px solid #e0e0e0",
                                                                transition: "all 0.3s ease"
                                                            }}
                                                            onMouseEnter={(e) => {
                                                                e.currentTarget.style.backgroundColor = "#e6ebff";
                                                                e.currentTarget.style.transform = "scale(1.002)";
                                                            }}
                                                            onMouseLeave={(e) => {
                                                                e.currentTarget.style.backgroundColor = "#f0f4ff";
                                                                e.currentTarget.style.transform = "scale(1)";
                                                            }}>
                                                            <td style={{
                                                                padding: "20px 10px",
                                                                borderRight: "1px solid #e0e0e0",
                                                                fontWeight: "bold",
                                                                fontSize: "16px",
                                                                color: "#6c63ff",
                                                                textAlign: "center",
                                                                verticalAlign: "top"
                                                            }}>{index + 1}</td>
                                                            <td style={{
                                                                padding: "10px 5px",
                                                                borderRight: "1px solid #e0e0e0",
                                                                fontWeight: "bold",
                                                                fontSize: "18px",
                                                                color: "#333",
                                                                overflow: "hidden",
                                                                textOverflow: "ellipsis",
                                                                whiteSpace: "nowrap"
                                                            }}>
                                                                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                                    <div style={{
                                                                        width: "8px",
                                                                        height: "8px",
                                                                        backgroundColor: "#6c63ff",
                                                                        borderRadius: "50%",
                                                                        animation: "pulse 2s infinite",
                                                                        flexShrink: 0
                                                                    }}></div>
                                                                    <span style={{
                                                                        overflow: "hidden",
                                                                        textOverflow: "ellipsis",
                                                                        whiteSpace: "nowrap"
                                                                    }}>
                                                                        {category.catageoryName}
                                                                    </span>
                                                                </div>
                                                            </td>
                                                            <td style={{
                                                                padding: "10px 5px",
                                                                borderRight: "1px solid #e0e0e0",
                                                                textAlign: "center",
                                                                verticalAlign: "middle"
                                                            }}>
                                                                {renderImage(category.image, category.catageoryName)}
                                                            </td>
                                                            <td style={{
                                                                padding: "10px 5px",
                                                                display: "flex",
                                                                gap: "10px",
                                                                alignItems: "center",
                                                                justifyContent: "flex-start",
                                                                flexWrap: "wrap"
                                                            }}>
                                                                <button
                                                                    onClick={() => handleAddClick(category)}
                                                                    style={{
                                                                        background: "linear-gradient(135deg, rgb(230 109 51) 0%, rgb(230 109 51) 100%)",
                                                                        color: "white",
                                                                        border: "none",
                                                                        padding: "10px 15px",
                                                                        borderRadius: "8px",
                                                                        cursor: "pointer",
                                                                        fontSize: "13px",
                                                                        fontWeight: "600",
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        gap: "6px",
                                                                        transition: "all 0.3s ease",
                                                                        boxShadow: "0 4px 15px rgba(102, 126, 234, 0.3)",
                                                                        flexShrink: 0,
                                                                        whiteSpace: "nowrap"
                                                                    }}
                                                                    onMouseEnter={(e) => {
                                                                        e.target.style.transform = "translateY(-2px)";
                                                                        e.target.style.boxShadow = "0 8px 25px rgba(102, 126, 234, 0.4)";
                                                                    }}
                                                                    onMouseLeave={(e) => {
                                                                        e.target.style.transform = "translateY(0)";
                                                                        e.target.style.boxShadow = "0 4px 15px rgba(102, 126, 234, 0.3)";
                                                                    }}
                                                                >
                                                                    <FaPlus size={11} /> Add Dish
                                                                </button>
                                                                <div style={{ display: "flex", gap: "8px", flexShrink: 0 }}>
                                                                    <FaEdit
                                                                        onClick={() => handleEditCategoryClick(category)}
                                                                        onMouseEnter={() => setHoveredEdit(`category-${category.catageoryId}`)}
                                                                        onMouseLeave={() => setHoveredEdit(null)}
                                                                        style={{
                                                                            fontSize: "18px",
                                                                            cursor: "pointer",
                                                                            color: hoveredEdit === `category-${category.catageoryId}` ? "#007bff" : "#6c757d",
                                                                            transition: "all 0.3s ease",
                                                                            transform: hoveredEdit === `category-${category.catageoryId}` ? "scale(1.2)" : "scale(1)",
                                                                        }}
                                                                    />
                                                                    <FaTrash
                                                                        onClick={() => handleDeleteCategory(category.catageoryId)}
                                                                        onMouseEnter={() => setHoveredDelete(`category-${category.catageoryId}`)}
                                                                        onMouseLeave={() => setHoveredDelete(null)}
                                                                        style={{
                                                                            fontSize: "18px",
                                                                            cursor: "pointer",
                                                                            color: hoveredDelete === `category-${category.catageoryId}` ? "#ff4444" : "#dc3545",
                                                                            transition: "all 0.3s ease",
                                                                            transform: hoveredDelete === `category-${category.catageoryId}` ? "scale(1.2)" : "scale(1)",
                                                                        }}
                                                                    />
                                                                </div>
                                                            </td>
                                                        </tr>

                                                        {/* Dish Rows */}
                                                        {/* Dish Rows */}
                                                        {categoryDishes.map((dish, dishIndex) => (
                                                            <tr
                                                                key={dish.id}
                                                                data-dish-id={dish.id}
                                                                style={{
                                                                    backgroundColor: dishIndex % 2 === 0 ? "#fafafa" : "#f5f5f5",
                                                                    borderBottom: dishIndex === categoryDishes.length - 1 ? "2px solid #e0e0e0" : "1px solid #eee",
                                                                    transition: "all 0.3s ease",
                                                                    opacity: 1,
                                                                    transform: "translateX(0)"
                                                                }}
                                                                onMouseEnter={(e) => {
                                                                    e.currentTarget.style.backgroundColor = "#f0f8ff";
                                                                }}
                                                                onMouseLeave={(e) => {
                                                                    e.currentTarget.style.backgroundColor = dishIndex % 2 === 0 ? "#fafafa" : "#f5f5f5";
                                                                }}
                                                            >
                                                                <td style={{
                                                                    padding: "15px 10px 15px 15px",
                                                                    borderRight: "1px solid #e0e0e0",
                                                                    color: "#999",
                                                                    fontSize: "14px",
                                                                    textAlign: "center",
                                                                    verticalAlign: "middle"
                                                                }}>
                                                                    {/* Display dish serial number as index+1.counter */}
                                                                    {index + 1}.{dishIndex + 1}
                                                                </td>
                                                                <td style={{
                                                                    padding: "10px 5px",
                                                                    borderRight: "1px solid #e0e0e0",
                                                                    color: "#555",
                                                                    fontSize: "15px",
                                                                    fontWeight: "500",
                                                                    overflow: "hidden",
                                                                    textOverflow: "ellipsis",
                                                                    whiteSpace: "nowrap"
                                                                }}>
                                                                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                                        <span style={{
                                                                            width: "6px",
                                                                            height: "6px",
                                                                            backgroundColor: "#ff6b6b",
                                                                            borderRadius: "50%",
                                                                            flexShrink: 0
                                                                        }}></span>
                                                                        <span style={{
                                                                            overflow: "hidden",
                                                                            textOverflow: "ellipsis",
                                                                            whiteSpace: "nowrap"
                                                                        }}>
                                                                            {dish.name}
                                                                        </span>
                                                                    </div>
                                                                </td>
                                                                <td style={{
                                                                    padding: "10px 5px",
                                                                    borderRight: "1px solid #e0e0e0",
                                                                    textAlign: "center",
                                                                    verticalAlign: "middle"
                                                                }}>
                                                                    {renderImage(dish.image, dish.name)}
                                                                </td>
                                                                <td style={{
                                                                    padding: "10px 5px",
                                                                    display: "flex",
                                                                    gap: "15px",
                                                                    justifyContent: "center",
                                                                    alignItems: "center"
                                                                }}>
                                                                    <FaEdit
                                                                        onClick={() => handleEditDishClick(dish.id)}
                                                                        onMouseEnter={() => setHoveredEdit(dish.id)}
                                                                        onMouseLeave={() => setHoveredEdit(null)}
                                                                        style={{
                                                                            fontSize: "18px",
                                                                            cursor: "pointer",
                                                                            color: hoveredEdit === dish.id ? "#007bff" : "#6c757d",
                                                                            transition: "all 0.3s ease",
                                                                            transform: hoveredEdit === dish.id ? "scale(1.2)" : "scale(1)",
                                                                            filter: hoveredEdit === dish.id ? "drop-shadow(0 2px 8px rgba(0, 123, 255, 0.4))" : "none"
                                                                        }}
                                                                    />
                                                                    <FaTrash
                                                                        onClick={() => handleDeleteDish(dish.id)}
                                                                        onMouseEnter={() => setHoveredDelete(dish.id)}
                                                                        onMouseLeave={() => setHoveredDelete(null)}
                                                                        style={{
                                                                            fontSize: "18px",
                                                                            cursor: "pointer",
                                                                            color: hoveredDelete === dish.id ? "#ff4444" : "#dc3545",
                                                                            transition: "all 0.3s ease",
                                                                            transform: hoveredDelete === dish.id ? "scale(1.2)" : "scale(1)",
                                                                            filter: hoveredDelete === dish.id ? "drop-shadow(0 2px 8px rgba(255, 68, 68, 0.4))" : "none"
                                                                        }}
                                                                    />
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </React.Fragment>
                                                );
                                            })
                                        ) : (
                                            <tr>
                                                <td colSpan="4" style={{
                                                    textAlign: "center",
                                                    padding: "60px",
                                                    color: "#999",
                                                    fontSize: "18px",
                                                    background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
                                                    borderRadius: "15px"
                                                }}>
                                                    <div style={{ marginBottom: "20px" }}>
                                                        <div style={{
                                                            width: "80px",
                                                            height: "80px",
                                                            margin: "0 auto 20px",
                                                            background: "linear-gradient(135deg, rgb(230 109 51) 0%, rgb(230 109 51) 100%)",
                                                            borderRadius: "50%",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            color: "white",
                                                            fontSize: "30px",
                                                            animation: "pulse 2s infinite"
                                                        }}>
                                                            🍽️
                                                        </div>
                                                    </div>
                                                    No categories found. Add your first category!
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        )}

                        {/* Add Category Modal */}
                        <Modal
                            isOpen={isQuickModal}
                            onRequestClose={() => {
                                setIsQuickModal(false);
                                setQuickForm({ catageory: "", image: null });
                            }}
                            style={{
                                overlay: {
                                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                    zIndex: 10000,
                                    position: 'fixed',
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                },
                                content: {
                                    position: 'relative',
                                    margin: 'auto',
                                    border: '1px solid #ccc',
                                    background: '#fff',
                                    overflow: 'auto',
                                    WebkitOverflowScrolling: 'touch',
                                    borderRadius: '8px',
                                    outline: 'none',
                                    padding: '20px',
                                    maxWidth: '400px',
                                    width: '90%',
                                    zIndex: 10001,
                                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
                                }
                            }}
                        >
                            <div style={{ position: 'relative' }}>
                                <h3 style={{
                                    margin: '0 0 20px 0',
                                    fontSize: '18px',
                                    fontWeight: '600',
                                    color: '#333',
                                    borderBottom: '1px solid #eee',
                                    paddingBottom: '10px'
                                }}>
                                    Add Category
                                </h3>

                                <div style={{ marginBottom: '20px' }}>
                                    <div style={{ marginBottom: '15px' }}>
                                        <label style={{
                                            display: 'block',
                                            marginBottom: '5px',
                                            fontSize: '14px',
                                            color: '#555',
                                            fontWeight: '500'
                                        }}>
                                            Category Name
                                        </label>
                                        <input
                                            type="text"
                                            name="catageory"
                                            placeholder="Enter category name"
                                            value={quickForm.catageory}
                                            onChange={handleQuickChange}
                                            style={{
                                                width: '100%',
                                                padding: '10px',
                                                border: '1px solid #ddd',
                                                borderRadius: '4px',
                                                fontSize: '14px',
                                                boxSizing: 'border-box'
                                            }}
                                        />
                                    </div>

                                    <div style={{ marginBottom: '15px' }}>
                                        <label style={{
                                            display: 'block',
                                            marginBottom: '5px',
                                            fontSize: '14px',
                                            color: '#555',
                                            fontWeight: '500'
                                        }}>
                                            Category Image
                                        </label>
                                        <input
                                            type="file"
                                            name="image"
                                            onChange={handleQuickChange}
                                            accept="image/*"
                                            style={{
                                                width: '100%',
                                                padding: '8px',
                                                border: '1px solid #ddd',
                                                borderRadius: '4px',
                                                fontSize: '14px'
                                            }}
                                        />
                                        {quickForm.image && (
                                            <div style={{
                                                marginTop: '5px',
                                                fontSize: '12px',
                                                color: '#28a745',
                                                fontStyle: 'italic'
                                            }}>
                                                Selected: {quickForm.image.name}
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                    gap: '10px',
                                    paddingTop: '15px',
                                    borderTop: '1px solid #eee'
                                }}>
                                    <button
                                        onClick={() => {
                                            setIsQuickModal(false);
                                            setQuickForm({ catageory: "", image: null });
                                        }}
                                        style={{
                                            padding: '8px 16px',
                                            background: '#f8f9fa',
                                            color: '#333',
                                            border: '1px solid #ddd',
                                            borderRadius: '4px',
                                            cursor: 'pointer',
                                            fontSize: '14px',
                                            transition: 'all 0.2s'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.target.style.background = '#e9ecef';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.target.style.background = '#f8f9fa';
                                        }}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        onClick={handleQuickSave}
                                        disabled={isLoading}
                                        style={{
                                            padding: '8px 16px',
                                            background: isLoading ? '#ccc' : 'rgb(230 109 51)',
                                            color: 'white',
                                            border: 'none',
                                            borderRadius: '4px',
                                            cursor: isLoading ? 'not-allowed' : 'pointer',
                                            fontSize: '14px',
                                            transition: 'all 0.2s',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '5px'
                                        }}
                                        onMouseEnter={(e) => {
                                            if (!isLoading) {
                                                e.target.style.background = 'rgb(230 109 51)';
                                            }
                                        }}
                                        onMouseLeave={(e) => {
                                            if (!isLoading) {
                                                e.target.style.background = 'rgb(230 109 51)';
                                            }
                                        }}
                                    >
                                        {isLoading ? (
                                            <>
                                                <FaSpinner style={{
                                                    animation: 'spin 1s linear infinite',
                                                    fontSize: '12px'
                                                }} />
                                                Adding...
                                            </>
                                        ) : 'Add'}
                                    </button>
                                </div>
                            </div>
                        </Modal>

                        {/* Add Dish Modal */}
                        <Modal
                            isOpen={isDetailModal}
                            onRequestClose={() => {
                                setIsDetailModal(false);
                                setDetailForm({
                                    id: "",
                                    catageoryId: "",
                                    dishName: "",
                                    image: null,
                                });
                                setSelectedCategoryName("");
                            }}
                            style={{
                                overlay: {
                                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                    zIndex: 10000,
                                    position: 'fixed',
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                },
                                content: {
                                    position: 'relative',
                                    margin: 'auto',
                                    border: '1px solid #ccc',
                                    background: '#fff',
                                    overflow: 'auto',
                                    WebkitOverflowScrolling: 'touch',
                                    borderRadius: '8px',
                                    outline: 'none',
                                    padding: '20px',
                                    maxWidth: '400px',
                                    width: '90%',
                                    zIndex: 10001,
                                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
                                }
                            }}
                        >
                            <div style={{ position: 'relative' }}>
                                <h3 style={{
                                    margin: '0 0 20px 0',
                                    fontSize: '18px',
                                    fontWeight: '600',
                                    color: '#333',
                                    borderBottom: '1px solid #eee',
                                    paddingBottom: '10px'
                                }}>
                                    Add Dish
                                </h3>

                                {selectedCategoryName && (
                                    <div style={{
                                        marginBottom: '15px',
                                        padding: '10px',
                                        background: '#f8f9fa',
                                        borderRadius: '4px',
                                        border: '1px solid #e9ecef',
                                        fontSize: '14px',
                                        color: '#666'
                                    }}>
                                        <strong>Category:</strong> {selectedCategoryName}
                                    </div>
                                )}

                                <div style={{ marginBottom: '20px' }}>
                                    <div style={{ marginBottom: '15px' }}>
                                        <label style={{
                                            display: 'block',
                                            marginBottom: '5px',
                                            fontSize: '14px',
                                            color: '#555',
                                            fontWeight: '500'
                                        }}>
                                            Dish Name
                                        </label>
                                        <input
                                            type="text"
                                            name="dishName"
                                            placeholder="Enter dish name"
                                            value={detailForm.dishName}
                                            onChange={handleDetailChange}
                                            style={{
                                                width: '100%',
                                                padding: '10px',
                                                border: '1px solid #ddd',
                                                borderRadius: '4px',
                                                fontSize: '14px',
                                                boxSizing: 'border-box'
                                            }}
                                        />
                                    </div>

                                    <div style={{ marginBottom: '15px' }}>
                                        <label style={{
                                            display: 'block',
                                            marginBottom: '5px',
                                            fontSize: '14px',
                                            color: '#555',
                                            fontWeight: '500'
                                        }}>
                                            Dish Image
                                        </label>
                                        <input
                                            type="file"
                                            name="image"
                                            onChange={handleDetailChange}
                                            accept="image/*"
                                            style={{
                                                width: '100%',
                                                padding: '8px',
                                                border: '1px solid #ddd',
                                                borderRadius: '4px',
                                                fontSize: '14px'
                                            }}
                                        />
                                        {detailForm.image && (
                                            <div style={{
                                                marginTop: '5px',
                                                fontSize: '12px',
                                                color: '#28a745',
                                                fontStyle: 'italic'
                                            }}>
                                                Selected: {detailForm.image.name}
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                    gap: '10px',
                                    paddingTop: '15px',
                                    borderTop: '1px solid #eee'
                                }}>
                                    <button
                                        onClick={() => {
                                            setIsDetailModal(false);
                                            setDetailForm({
                                                id: "",
                                                catageoryId: "",
                                                dishName: "",
                                                image: null,
                                            });
                                            setSelectedCategoryName("");
                                        }}
                                        style={{
                                            padding: '8px 16px',
                                            background: '#f8f9fa',
                                            color: '#333',
                                            border: '1px solid #ddd',
                                            borderRadius: '4px',
                                            cursor: 'pointer',
                                            fontSize: '14px',
                                            transition: 'all 0.2s'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.target.style.background = '#e9ecef';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.target.style.background = '#f8f9fa';
                                        }}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        onClick={handleDetailSave}
                                        disabled={isSaving}
                                        style={{
                                            padding: '8px 16px',
                                            background: isSaving ? '#ccc' : 'rgb(230 109 51)',
                                            color: 'white',
                                            border: 'none',
                                            borderRadius: '4px',
                                            cursor: isSaving ? 'not-allowed' : 'pointer',
                                            fontSize: '14px',
                                            transition: 'all 0.2s',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '5px'
                                        }}
                                        onMouseEnter={(e) => {
                                            if (!isSaving) {
                                                e.target.style.background = 'rgb(230 109 51)';
                                            }
                                        }}
                                        onMouseLeave={(e) => {
                                            if (!isSaving) {
                                                e.target.style.background = 'rgb(230 109 51)';
                                            }
                                        }}
                                    >
                                        {isSaving ? (
                                            <>
                                                <FaSpinner style={{
                                                    animation: 'spin 1s linear infinite',
                                                    fontSize: '12px'
                                                }} />
                                                Saving...
                                            </>
                                        ) : 'Add Dish'}
                                    </button>
                                </div>
                            </div>
                        </Modal>

                        {/* Edit Category Modal */}
                        <Modal
                            isOpen={isEditCategoryModal}
                            onRequestClose={() => {
                                setIsEditCategoryModal(false);
                                setEditCategoryForm({ catageoryId: "", catageoryName: "", image: null, currentImage: "" });
                            }}
                            style={{
                                overlay: {
                                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                    zIndex: 10000,
                                    position: 'fixed',
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                },
                                content: {
                                    position: 'relative',
                                    margin: 'auto',
                                    border: '1px solid #ccc',
                                    background: '#fff',
                                    overflow: 'auto',
                                    WebkitOverflowScrolling: 'touch',
                                    borderRadius: '8px',
                                    outline: 'none',
                                    padding: '20px',
                                    maxWidth: '400px',
                                    width: '90%',
                                    zIndex: 10001,
                                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
                                }
                            }}
                        >
                            <div style={{ position: 'relative' }}>
                                <h3 style={{
                                    margin: '0 0 20px 0',
                                    fontSize: '18px',
                                    fontWeight: '600',
                                    color: '#333',
                                    borderBottom: '1px solid #eee',
                                    paddingBottom: '10px'
                                }}>
                                    Edit Category
                                </h3>

                                <div style={{ marginBottom: '20px' }}>
                                    <div style={{ marginBottom: '15px' }}>
                                        <label style={{
                                            display: 'block',
                                            marginBottom: '5px',
                                            fontSize: '14px',
                                            color: '#555',
                                            fontWeight: '500'
                                        }}>
                                            Category Name
                                        </label>
                                        <input
                                            type="text"
                                            name="catageoryName"
                                            placeholder="Enter category name"
                                            value={editCategoryForm.catageoryName}
                                            onChange={handleEditCategoryChange}
                                            style={{
                                                width: '100%',
                                                padding: '10px',
                                                border: '1px solid #ddd',
                                                borderRadius: '4px',
                                                fontSize: '14px',
                                                boxSizing: 'border-box'
                                            }}
                                        />
                                    </div>

                                    <div style={{ marginBottom: '15px' }}>
                                        <label style={{
                                            display: 'block',
                                            marginBottom: '5px',
                                            fontSize: '14px',
                                            color: '#555',
                                            fontWeight: '500'
                                        }}>
                                            Category Image
                                        </label>

                                        {editCategoryForm.currentImage && (
                                            <div style={{
                                                marginBottom: '10px',
                                                padding: '8px',
                                                background: '#f8f9fa',
                                                borderRadius: '4px',
                                                border: '1px solid #e9ecef'
                                            }}>
                                                <div style={{
                                                    fontSize: '12px',
                                                    color: '#666',
                                                    marginBottom: '5px'
                                                }}>
                                                    Current Image:
                                                </div>
                                                <img
                                                    src={getValidImageUrl(editCategoryForm.currentImage)}
                                                    alt="Current"
                                                    style={{
                                                        width: '50px',
                                                        height: '50px',
                                                        objectFit: 'cover',
                                                        borderRadius: '4px',
                                                        border: '1px solid #ddd'
                                                    }}
                                                    onError={(e) => {
                                                        e.target.style.display = 'none';
                                                        e.target.parentElement.innerHTML = `
                                                            <div style="width: 50px; height: 50px; background: #6c757d; border-radius: 4px; display: flex; align-items: center; justify-content: center; color: white; font-size: 10px; font-weight: 600;">
                                                                No Image
                                                            </div>
                                                        `;
                                                    }}
                                                />
                                            </div>
                                        )}

                                        <input
                                            type="file"
                                            name="image"
                                            onChange={handleEditCategoryChange}
                                            accept="image/*"
                                            style={{
                                                width: '100%',
                                                padding: '8px',
                                                border: '1px solid #ddd',
                                                borderRadius: '4px',
                                                fontSize: '14px'
                                            }}
                                        />
                                        {editCategoryForm.image && (
                                            <div style={{
                                                marginTop: '5px',
                                                fontSize: '12px',
                                                color: '#28a745',
                                                fontStyle: 'italic'
                                            }}>
                                                New file: {editCategoryForm.image.name}
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                    gap: '10px',
                                    paddingTop: '15px',
                                    borderTop: '1px solid #eee'
                                }}>
                                    <button
                                        onClick={() => {
                                            setIsEditCategoryModal(false);
                                            setEditCategoryForm({ catageoryId: "", catageoryName: "", image: null, currentImage: "" });
                                        }}
                                        style={{
                                            padding: '8px 16px',
                                            background: '#f8f9fa',
                                            color: '#333',
                                            border: '1px solid #ddd',
                                            borderRadius: '4px',
                                            cursor: 'pointer',
                                            fontSize: '14px',
                                            transition: 'all 0.2s'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.target.style.background = '#e9ecef';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.target.style.background = '#f8f9fa';
                                        }}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        onClick={handleUpdateCategory}
                                        disabled={isLoading}
                                        style={{
                                            padding: '8px 16px',
                                            background: isLoading ? '#ccc' : 'rgb(230 109 51)',
                                            color: 'white',
                                            border: 'none',
                                            borderRadius: '4px',
                                            cursor: isLoading ? 'not-allowed' : 'pointer',
                                            fontSize: '14px',
                                            transition: 'all 0.2s',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '5px'
                                        }}
                                        onMouseEnter={(e) => {
                                            if (!isLoading) {
                                                e.target.style.background = 'rgb(230 109 51)';
                                            }
                                        }}
                                        onMouseLeave={(e) => {
                                            if (!isLoading) {
                                                e.target.style.background = 'rgb(230 109 51)';
                                            }
                                        }}
                                    >
                                        {isLoading ? (
                                            <>
                                                <FaSpinner style={{
                                                    animation: 'spin 1s linear infinite',
                                                    fontSize: '12px'
                                                }} />
                                                Updating...
                                            </>
                                        ) : 'Update'}
                                    </button>
                                </div>
                            </div>
                        </Modal>

                        {/* Edit Dish Modal */}
                        <Modal
                            isOpen={isEditDishModal}
                            onRequestClose={() => {
                                setIsEditDishModal(false);
                                setEditDishForm({ id: "", name: "", image: null, currentImage: "", catageoryId: "" });
                            }}
                            style={{
                                overlay: {
                                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                    zIndex: 10000,
                                    position: 'fixed',
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                },
                                content: {
                                    position: 'relative',
                                    margin: 'auto',
                                    border: '1px solid #ccc',
                                    background: '#fff',
                                    overflow: 'auto',
                                    WebkitOverflowScrolling: 'touch',
                                    borderRadius: '8px',
                                    outline: 'none',
                                    padding: '20px',
                                    maxWidth: '400px',
                                    width: '90%',
                                    zIndex: 10001,
                                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
                                }
                            }}
                        >
                            <div style={{ position: 'relative' }}>
                                <h3 style={{
                                    margin: '0 0 20px 0',
                                    fontSize: '18px',
                                    fontWeight: '600',
                                    color: '#333',
                                    borderBottom: '1px solid #eee',
                                    paddingBottom: '10px'
                                }}>
                                    Edit Dish
                                </h3>

                                <div style={{ marginBottom: '20px' }}>
                                    <div style={{ marginBottom: '15px' }}>
                                        <label style={{
                                            display: 'block',
                                            marginBottom: '5px',
                                            fontSize: '14px',
                                            color: '#555',
                                            fontWeight: '500'
                                        }}>
                                            Dish Name
                                        </label>
                                        <input
                                            type="text"
                                            name="name"
                                            placeholder="Enter dish name"
                                            value={editDishForm.name}
                                            onChange={handleEditDishChange}
                                            style={{
                                                width: '100%',
                                                padding: '10px',
                                                border: '1px solid #ddd',
                                                borderRadius: '4px',
                                                fontSize: '14px',
                                                boxSizing: 'border-box'
                                            }}
                                        />
                                    </div>

                                    <div style={{ marginBottom: '15px' }}>
                                        <label style={{
                                            display: 'block',
                                            marginBottom: '5px',
                                            fontSize: '14px',
                                            color: '#555',
                                            fontWeight: '500'
                                        }}>
                                            Dish Image
                                        </label>

                                        {editDishForm.currentImage && (
                                            <div style={{
                                                marginBottom: '10px',
                                                padding: '8px',
                                                background: '#f8f9fa',
                                                borderRadius: '4px',
                                                border: '1px solid #e9ecef'
                                            }}>
                                                <div style={{
                                                    fontSize: '12px',
                                                    color: '#666',
                                                    marginBottom: '5px'
                                                }}>
                                                    Current Image:
                                                </div>
                                                <img
                                                    src={getValidImageUrl(editDishForm.currentImage)}
                                                    alt="Current"
                                                    style={{
                                                        width: '50px',
                                                        height: '50px',
                                                        objectFit: 'cover',
                                                        borderRadius: '4px',
                                                        border: '1px solid #ddd'
                                                    }}
                                                    onError={(e) => {
                                                        e.target.style.display = 'none';
                                                        e.target.parentElement.innerHTML = `
                                                            <div style="width: 50px; height: 50px; background: #6c757d; border-radius: 4px; display: flex; align-items: center; justify-content: center; color: white; font-size: 10px; font-weight: 600;">
                                                                No Image
                                                            </div>
                                                        `;
                                                    }}
                                                />
                                            </div>
                                        )}

                                        <input
                                            type="file"
                                            name="image"
                                            onChange={handleEditDishChange}
                                            accept="image/*"
                                            style={{
                                                width: '100%',
                                                padding: '8px',
                                                border: '1px solid #ddd',
                                                borderRadius: '4px',
                                                fontSize: '14px'
                                            }}
                                        />
                                        {editDishForm.image && (
                                            <div style={{
                                                marginTop: '5px',
                                                fontSize: '12px',
                                                color: '#28a745',
                                                fontStyle: 'italic'
                                            }}>
                                                New file: {editDishForm.image.name}
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                    gap: '10px',
                                    paddingTop: '15px',
                                    borderTop: '1px solid #eee'
                                }}>
                                    <button
                                        onClick={() => {
                                            setIsEditDishModal(false);
                                            setEditDishForm({ id: "", name: "", image: null, currentImage: "", catageoryId: "" });
                                        }}
                                        style={{
                                            padding: '8px 16px',
                                            background: '#f8f9fa',
                                            color: '#333',
                                            border: '1px solid #ddd',
                                            borderRadius: '4px',
                                            cursor: 'pointer',
                                            fontSize: '14px',
                                            transition: 'all 0.2s'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.target.style.background = '#e9ecef';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.target.style.background = '#f8f9fa';
                                        }}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        onClick={handleUpdateDish}
                                        disabled={isSaving}
                                        style={{
                                            padding: '8px 16px',
                                            background: isSaving ? '#ccc' : 'rgb(230 109 51)',
                                            color: 'white',
                                            border: 'none',
                                            borderRadius: '4px',
                                            cursor: isSaving ? 'not-allowed' : 'pointer',
                                            fontSize: '14px',
                                            transition: 'all 0.2s',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '5px'
                                        }}
                                        onMouseEnter={(e) => {
                                            if (!isSaving) {
                                                e.target.style.background = 'rgb(230 109 51)';
                                            }
                                        }}
                                        onMouseLeave={(e) => {
                                            if (!isSaving) {
                                                e.target.style.background = 'rgb(230 109 51)';
                                            }
                                        }}
                                    >
                                        {isSaving ? (
                                            <>
                                                <FaSpinner style={{
                                                    animation: 'spin 1s linear infinite',
                                                    fontSize: '12px'
                                                }} />
                                                Updating...
                                            </>
                                        ) : 'Update'}
                                    </button>
                                </div>
                            </div>
                        </Modal>
                    </div>
                </div>
            </div>

            <style>{`
                @keyframes fadeIn {
                    from { opacity: 0; }
                    to { opacity: 1; }
                }
                
                @keyframes slideUp {
                    from { 
                        opacity: 0;
                        transform: translateY(30px);
                    }
                    to { 
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
                
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
                
                @keyframes pulse {
                    0% { transform: scale(1); }
                    50% { transform: scale(1.05); }
                    100% { transform: scale(1); }
                }
                
                @keyframes shake {
                    0%, 100% { transform: translateX(0); }
                    10%, 30%, 50%, 70%, 90% { transform: translateX(-5px); }
                    20%, 40%, 60%, 80% { transform: translateX(5px); }
                }
                
                @keyframes letterAnim {
                    0% { opacity: 0; transform: translateY(30px); }
                    100% { opacity: 1; transform: translateY(0); }
                }

                @keyframes progress {
                    0% { transform: translateX(-100%); }
                    100% { transform: translateX(250%); }
                }
                
                /* Custom scrollbar styling */
                ::-webkit-scrollbar {
                    width: 10px;
                    height: 10px;
                }
                
                ::-webkit-scrollbar-track {
                    background: linear-gradient(180deg, #f5f7fa 0%, #c3cfe2 100%);
                    border-radius: 10px;
                }
                
                ::-webkit-scrollbar-thumb {
                    background: linear-gradient(135deg, rgb(230 109 51) 0%, rgb(230 109 51) 100%);
                    border-radius: 10px;
                    border: 2px solid #f5f7fa;
                }
                
                ::-webkit-scrollbar-thumb:hover {
                    background: linear-gradient(135deg, #5a67d8 0%, #6b46c1 100%);
                }
                
                /* For Firefox */
                * {
                    scrollbar-width: thin;
                    scrollbar-color: rgb(230 109 51) #f5f7fa;
                }
                
                /* Smooth transitions */
                * {
                    transition: background-color 0.3s ease, 
                                border-color 0.3s ease, 
                                transform 0.3s ease,
                                box-shadow 0.3s ease;
                }
                
                /* Image hover effects */
                .dish-image:hover {
                    transform: scale(1.1) rotate(2deg);
                }
                
                /* Table row hover effect */
                tr {
                    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
                }
                
                /* Modal backdrop blur */
                .ReactModal__Overlay {
                    backdrop-filter: blur(5px);
                }
                
                /* Loading spinner */
                .spinner {
                    display: inline-block;
                    animation: spin 1s linear infinite;
                }
            `}</style>
        </div>
    );
}